

module.exports = __webpack_require__.stylable.create(
    "DropdownBase1747517927",
    {"classes":{"root":"DropdownBase1747517927__root","arrowIcon":"DropdownBase1747517927__arrowIcon","optionIcon":"DropdownBase1747517927__optionIcon","childrenWrapper":"DropdownBase1747517927__childrenWrapper"},"vars":{},"stVars":{"BorderHoverColor":"color-5","borderHoverColor":"\"color(color-5)\"","DefaultBorderWidth":"1px"},"keyframes":{}},
    "",
    8,
    "DropdownBase1747517927",
    null
);
